import { Box, Stack, Typography } from '@mui/material';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { useNotificationsFilter } from '../hooks/useNotificationsFilter';
import NotificationSidebar from '../components/NotificationSidebar';
import { NotificationSetting } from '../components/NotificationSetting';
import NotificationFilters from '../components/NotificationFilters';
import NotificationWrapper from '../components/NotificationWrapper';
import { withTracking } from '../../../modules/analytics/withTracking';
import { NOTIFICATION_OPENED } from '../../../modules/analytics/events';

const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
  overflow: 'hidden',
};

const contentAreaStyles = {
  display: 'flex',
  flex: 1,
  overflow: 'hidden',
  minHeight: 0,
};

const mainContentStyles = {
  flex: 1,
  px: 3,
  py: 2,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
};

const Notifications: React.FC = () => {
  const { t } = useTranslation();
  const { apiFilters, urlParams, onSelect } = useNotificationsFilter();

  return (
    <Box sx={containerStyles}>
      <Box sx={contentAreaStyles}>
        <NotificationSidebar
          selectedTypes={urlParams.type}
          selectedModules={urlParams.module}
          onSelect={onSelect}
        />
        <Box sx={mainContentStyles}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
            <Typography variant="title">{t('notifications.title', 'Notifications')}</Typography>
            <NotificationSetting />
          </Stack>

          <NotificationFilters
            searchQuery={urlParams.search}
            selectedFilters={urlParams.filter}
            onSelect={onSelect}
          />

          <Box sx={{ flex: 1, overflow: 'hidden', mt: 2 }}>
             <NotificationWrapper filters={apiFilters} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default withTracking(Notifications, {
  lifecycle: {
    onMount: {
      event: NOTIFICATION_OPENED,
      properties: { source: 'notifications_page' }
    }
  }
});